import Result from "@/core/common/Result";

export interface IUsuarioPorEmpresaResponse {
  id: string;
  nome?: string;
  email: string;
}

export interface IUsuariosPorEmpresaGateway {
  getUsers(empresaId: string[]): Promise<Result<IUsuarioPorEmpresaResponse[]>>;
}

export const usuariosPorEmpresaGatewayDI = Symbol("usuariosPorEmpresaDI");
